import { useStaticQuery, graphql } from 'gatsby';


export const useAlertBarQuery = () => {
  const data = useStaticQuery(graphql`
    query AlertBarQuery {
      wp {
        sitewideSettings {
          optionsSitewideSettings {
            alertBar {
              backgroundColor {
                color
              }
              backgroundImage {
                mediaItemUrl
              }
              enabled
              excludedPaths
              href
              icon {
                iconName
              }
              message
              openInNewTab
              showIcon
              textColor {
                color
              }
            }
          }
        }
      }
    }
  `);

  const {
    backgroundColor,
    backgroundImage,
    enabled,
    excludedPaths = '',
    href,
    icon,
    message = '',
    openInNewTab,
    showIcon,
    textColor,
  } = data?.wp?.sitewideSettings?.optionsSitewideSettings?.alertBar || {};

  return {
    backgroundColor: backgroundColor?.color,
    backgroundImage: backgroundImage?.mediaItemUrl,
    enabled,
    excludedPaths: excludedPaths?.replace(/[\r\n]+/g, ' ')?.split(' ')?.filter(Boolean) || [],
    href,
    icon: icon?.iconName,
    message,
    openInNewTab,
    showIcon,
    textColor: textColor?.color,
  };
};
